import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from './PreviewSlide.module.scss';
import quoteIcon from '../../../assets/Imagess/quote.svg';

const PreviewSlide = ({
  open,
  onClose,
  mediaUrl,
  isVideo,
  title,
  slideType,
  description,
  withSound,
  withHue,
}) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === 'Escape' && onClose();
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  const content = (
    <div className={styles.overlay} onClick={onClose}>
      {isVideo ? (
        <video
          className={styles.bg}
          src={mediaUrl}
          autoPlay
          loop
          playsInline
          muted={!withSound}
        />
      ) : (
        <img className={styles.bg} src={mediaUrl} alt='' />
      )}
      {withHue && <div className={styles.hue} />}
      <div className={styles.center} onClick={(e) => e.stopPropagation()}>
        {title && slideType === 1 ? (
          <div className={styles['desc-quote']}>
            <img src={quoteIcon} className={styles['q-open']} />
            <img src={quoteIcon} className={styles['q-close']} />
            <span className={`${styles.line} ${styles['line-top']}`} />
            <span className={`${styles.line} ${styles['line-right']}`} />
            <span className={`${styles.line} ${styles['line-left']}`} />
            <span className={`${styles.line} ${styles['line-bottom']}`} />

            <p className={styles.title}>{title}</p>
          </div>
        ) : null}
        {title && slideType === 0 ? (
          <p className={styles.title}>{title}</p>
        ) : null}
        {slideType === 0 && description ? (
          <div
            className={styles.desc}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        ) : null}
      </div>
      <button type='button' className={styles.close} onClick={onClose}>
        ✕
      </button>
    </div>
  );

  return createPortal(content, document.body);
};

export default PreviewSlide;
